// extracted by mini-css-extract-plugin
export default {"container":"PreviewCategories_container__-2uE4","groupIcon":"PreviewCategories_groupIcon__t1ZID","tag":"PreviewCategories_tag__Sss6j"};